const objUtil = {
  /**
   *
   * @param obj
   * @param fieldsArr 指定需要复制的字段
   * @returns {*}
   */
  clone(obj, fieldsArr = []) {
    let o
      let isFirst = true
    switch (typeof obj) {
      case 'undefined': break
      case 'string' : o = `${obj}`; break
      case 'number' : o = obj - 0; break
      case 'boolean' : o = obj; break
      case 'object' :
        if (obj === null) {
          o = null
        } else if (obj instanceof Array) {
          o = []
          for (let i = 0, len = obj.length; i < len; i += 1) {
            o.push(this.clone(obj[i]))
          }
        } else {
          o = {}
          if(fieldsArr.length && isFirst) {
              isFirst = false
              Object.keys(obj).forEach((k) => {
                if(fieldsArr.includes(k)) {
                    o[k] = this.clone(obj[k])
                }
              })
          } else {
              Object.keys(obj).forEach((k) => {
                  o[k] = this.clone(obj[k])
              })
          }

        }
        break
      default:
        o = obj; break
    }
    return o
  },
}

export default objUtil

